import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Button, Tab, Tabs } from "react-bootstrap";
import i18n from "i18next";
import ToggleSwitch from "@trendmicro/react-toggle-switch";
import { ID_PREFIX_FILE } from "../../../../../../common/constants.es6";
import ImageStyleLibrary from "../../../../image_style_library/ImageStyleLibrary";

export default function ImgTextToImageComponent(props) {
  const { onElementSelected, onServerModal, ttiGenerateImageFile, icon, name } = props;

  const [promptText, setPromptText] = useState("");
  const [processing, setProcessing] = useState(false);
  const [fileUrl, setFileUrl] = useState("");
  const [soundLoaded, setSoundLoaded] = useState(false);
  const [improvePromptChecked, setImprovePromptChecked] = useState(false);
  const [provider, setProvider] = useState("gemini-nano");
  const [orientation, setOrientation] = useState("square");
  const [quality, setQuality] = useState("hd");
  const [activeTab, setActiveTab] = useState("styleLibrary");

  const handlePromptTextChange = (e) => {
    setPromptText(e.target.value);
  };

  const handleProviderChange = (e) => {
    setProvider(e.target.value);
  };

  const handleOrientationChange = (e) => {
    setOrientation(e.target.value);
  };

  const handleQualityChange = (e) => {
    setQuality(e.target.value);
  };

  const handleImprovePromptChange = () => {
    setImprovePromptChecked((prev) => !prev);
  };

  const handleTabSelect = (tab) => {
    setActiveTab(tab || "styleLibrary");
  };

  const textareaStyle = { width: "100%" };
  const selectStyle = { width: "auto", display: "inline" };
  const imageStyle = { width: "auto", height: "128px" };

  const ttiGenerateImageHandler = (e) => {
    let _prompt = promptText;
    let _provider = provider;
    let _orientation = orientation;
    let _quality = quality;
    let _improvePrompt = improvePromptChecked;
    let _imgCount = 1;

    if (_prompt.replaceAll(" ", "") == "") {
      onServerModal(
        i18n.t("error.warning"),
        "<span>" + i18n.t("YouMustEnterAPromptText") + "</span>",
        false
      );
      return;
    }

    let idd = ID_PREFIX_FILE + Date.now();
    let fnamee = "AI-" + _prompt;
    if (_prompt.length > 50) {
      fnamee = "AI-" + _prompt.substring(0, 50);
    }

    ttiGenerateImageFile(
      {
        prompt: _prompt,
        provider: _provider,
        orientation: _orientation,
        imgCount: _imgCount,
        id: idd,
        fileName: fnamee,
        quality: _quality,
        aiImprovePrompt: _improvePrompt,
      },
      (isSuccess, errorStr, fileUrl, subscriptionUsed, subscriptionLimit) => {
        if (isSuccess && fileUrl != "") {
          setProcessing(false);
          setFileUrl(fileUrl);
          setSoundLoaded(true);
          onElementSelected(fnamee, fileUrl, "image", idd);
        } else {
          onServerModal(
            i18n.t("FileModal.APIProviders.error"),
            "<span>" + errorStr + "</span>",
            false
          );
          setProcessing(false);
          setFileUrl("");
          setSoundLoaded(false);
        }
      }
    );
    setProcessing(true);
    setFileUrl("");
    setSoundLoaded(false);
    e.stopPropagation();
  };

  return (
    <div
      className="contentComponent"
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        overflow: "hidden",
      }}
    >
      <style>{`
        #image-generation-tabs {
          margin-bottom: 8px;
          border-bottom: 1px solid #e5e7eb !important;
        }
        #image-generation-tabs .nav {
          border-bottom: none !important;
        }
        #image-generation-tabs .nav-item {
          margin-right: 4px;
        }
        #image-generation-tabs .nav-item .nav-link,
        #image-generation-tabs .nav > li > a,
        #image-generation-tabs ul > li > a {
          background-color: transparent !important;
          border: none !important;
          border-radius: 999px !important;
          color: #4b5563 !important;
          padding: 6px 12px !important;
          font-size: 13px !important;
          line-height: 1.2 !important;
        }
        #image-generation-tabs .nav-item .nav-link.active,
        #image-generation-tabs .nav > li.active > a,
        #image-generation-tabs ul > li.active > a {
          background-color: #ede9fe !important;
          color: #7c3aed !important;
        }
        #image-generation-tabs .tab-content {
          border: none !important;
        }
      `}</style>

      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          overflowY: "auto",
          padding: "8px 8px 12px 0",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: 8,
            gap: 8,
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            {icon ? (
              <img className="fileMenuIcon" src={icon} alt="" />
            ) : (
              <span style={{ fontWeight: 600 }}>{name}</span>
            )}
            <span style={{ fontSize: 13, color: "#6b7280" }}>
              {i18n.t("YouCanProceedUsingTheFollowingOptionsToCreateImagesWithAI")}
            </span>
          </div>
        </div>

        <Tabs
          activeKey={activeTab}
          onSelect={handleTabSelect}
          id="image-generation-tabs"
          className="custom-tabs"
        >
          <Tab
            eventKey="styleLibrary"
            title={i18n.t("ImgTextToImage.TabStyleLibrary") || "Style Library"}
          >
            <div style={{ marginTop: 12 }}>
              <ImageStyleLibrary
                onElementSelected={onElementSelected}
                onServerModal={onServerModal}
              />
            </div>
          </Tab>
          <Tab
            eventKey="traditional"
            title={i18n.t("ImgTextToImage.TabTraditionalMode") || "Traditional Mode"}
          >
            <div
              style={{
                marginTop: 12,
                display: "flex",
                flexDirection: "column",
                gap: 12,
              }}
            >
              <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                <span style={{ fontWeight: 500, fontSize: 14 }}>{i18n.t("AiText")}</span>
                <textarea
                  id="tti_prompttext"
                  maxLength={1024}
                  className="form-control"
                  style={textareaStyle}
                  rows="4"
                  value={promptText}
                  onChange={handlePromptTextChange}
                  placeholder={i18n.t("DefineTheImageYouWantToCreate")}
                ></textarea>
              </div>

              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <ToggleSwitch onChange={handleImprovePromptChange} checked={improvePromptChecked} />
                <span style={{ fontSize: 13 }}>{i18n.t("ImprovePrompt")}</span>
              </div>

              <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                <span style={{ fontWeight: 500, fontSize: 14 }}>
                  {i18n.t("FileModal.APIProviders.ImageStyles.AIProvider")}
                </span>
                <select
                  id="tti_provider"
                  className="form-control"
                  value={provider}
                  onChange={handleProviderChange}
                  style={selectStyle}
                >
                  <option value="flux">
                    {i18n.t("ImgTextToImage.Provider.Flux") || "Flux – 1.1 Pro"}
                  </option>
                  <option value="gemini-nano">
                    {i18n.t("ImgTextToImage.Provider.GeminiNano") || "Gemini – 3.1 Flash Image"}
                  </option>
                  <option value="grok">{i18n.t("ImgTextToImage.Provider.Grok") || "Grok"}</option>
                  <option value="gpt-image">
                    {i18n.t("ImgTextToImage.Provider.GPTImage") || "GPT-image-1.5"}
                  </option>
                </select>
              </div>

              <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                <span style={{ fontWeight: 500, fontSize: 14 }}>
                  {i18n.t("FileModal.APIProviders.ImageStyles.Orientation")}
                </span>
                <select
                  id="tti_orientation"
                  className="form-control"
                  value={orientation}
                  onChange={handleOrientationChange}
                  style={selectStyle}
                >
                  <option value="square">
                    {i18n.t("FileModal.APIProviders.ImageStyles.Square")}
                  </option>
                  <option value="landscape">
                    {i18n.t("FileModal.APIProviders.ImageStyles.Landscape")}
                  </option>
                  <option value="portrait">
                    {i18n.t("FileModal.APIProviders.ImageStyles.Portrait")}
                  </option>
                </select>
              </div>

              <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                <span style={{ fontWeight: 500, fontSize: 14 }}>
                  {i18n.t("FileModal.APIProviders.ImageStyles.Quality")}
                </span>
                <select
                  id="tti_quality"
                  className="form-control"
                  value={quality}
                  onChange={handleQualityChange}
                  style={selectStyle}
                >
                  <option value="hd">
                    {i18n.t("FileModal.APIProviders.ImageStyles.HDQuality")}
                  </option>
                  <option value="standard">
                    {i18n.t("FileModal.APIProviders.ImageStyles.Standard")}
                  </option>
                </select>
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginTop: 4,
                }}
              >
                <Button
                  id="tti_createfile"
                  className="btn-primary"
                  disabled={processing}
                  onClick={ttiGenerateImageHandler}
                >
                  {i18n.t("Create")}
                </Button>
                <span
                  id="tti_usage"
                  style={{
                    fontSize: 13,
                    color: "#6b7280",
                    visibility: processing ? "visible" : "hidden",
                  }}
                >
                  {i18n.t("ImgTextToImage.WaitMessage") || "Please wait..."}
                </span>
              </div>

              {soundLoaded && fileUrl && (
                <div
                  id="tti_file_row"
                  style={{
                    marginTop: 10,
                    marginBottom: 10,
                    textAlign: "center",
                  }}
                >
                  <img id="tti_file" src={fileUrl} style={imageStyle} />
                  <h6>
                    {i18n.t("TheImageYouCreatedHasBeenAddedToMyFiles")}
                    <br />
                    {i18n.t(
                      "YouCanAccessTheImagesYouHavePreviouslyCreatedHereOrDeleteTheImagesYouDoNotUse"
                    )}
                  </h6>
                </div>
              )}
            </div>
          </Tab>
        </Tabs>
      </div>
    </div>
  );
}

ImgTextToImageComponent.propTypes = {
  /**
   * Selected Element
   */
  elementSelected: PropTypes.any,
  /**
   * Select element callback
   */
  onElementSelected: PropTypes.func.isRequired,
  /**
   * Icon that identifies the API provider
   */
  icon: PropTypes.any,
  /**
   * API Provider name
   */
  name: PropTypes.string,
};
